
import { initiateOutboundCall } from "../ai/elevenLabsService/callService";
import { TestCallInput } from "@/types/admin";

export const runTestCall = async (input: TestCallInput): Promise<{ success: boolean; callId?: string; conversationId?: string; error?: string }> => {
  try {
    const { phoneNumber, agentId, script, phoneNumberId, variables } = input;
    
    if (!phoneNumber) {
      throw new Error("Phone number is required");
    }
    
    if (!agentId) {
      throw new Error("Agent ID is required");
    }
    
    // Log variables for debugging
    if (variables && Object.keys(variables).length > 0) {
      console.log("Sending variables to ElevenLabs:", variables);
    } else {
      console.log("No variables being sent with test call");
    }
    
    // Initialize the outbound call using ElevenLabs Agents API
    const result = await initiateOutboundCall(
      phoneNumber, 
      agentId,
      undefined, // No voice ID override 
      script || undefined, // Make sure script is undefined when it's empty/null
      phoneNumberId || undefined, // Make sure phoneNumberId is undefined when it's empty/null
      variables // Pass variables if available
    );
    
    if (!result.success) {
      throw new Error(result.error || "Failed to initiate call");
    }
    
    return {
      success: true,
      callId: result.callId,
      conversationId: result.conversationId
    };
  } catch (error) {
    console.error("Error running test call:", error);
    return {
      success: false,
      error: error instanceof Error ? error.message : "An unknown error occurred",
    };
  }
};
